import React, { useState } from 'react'
import { FacilityDetailsPropTypes } from './FacilityDetailsPropTypes'
import { Box, Flex, Image, Text, Wrap, WrapItem } from '@chakra-ui/react';

export const FacilityDetails = ({ variant, textOverlay, galleryMedia = [] }: FacilityDetailsPropTypes.IFacilityDetailsProps) => {

    const [selectedIndex, setSelectedIndex] = useState(0);

    return (
        <Flex w={'100%'} gap='56px' justifyContent={'center'}>
            <Flex
                direction={{ base: 'column', lg: variant === "vertical" ? 'column' : 'row' }}
                gap='56px'
                color={'text.grey'}
                alignItems={{ base: 'center', lg: variant === "vertical" ? 'center' : 'start' }}
                justifyContent={'center'}
                maxW={{ sm: '720px', md: '1092px' }}
            >
                <Box width={{ base: 'auto', sm: '100%', md: '500px' }} justifyContent={'center'}>
                    {galleryMedia && <Image src={galleryMedia[selectedIndex].url} alt={`Facility-Details-Image-${selectedIndex + 1}`} width={{ base: '100%', sm: '100%', md: '500px' }} height={{ sm: '500px' }}></Image>}
                    <Wrap spacing='8px' justify='center' mt={'8px'} width={{ base: 'auto', sm: '100%', md: '500px' }}>

                        {galleryMedia.length > 1 && galleryMedia.map(({ url }, index) => {
                            return <WrapItem>
                                <Image src={url} key={index} border={index === selectedIndex ? '3px inset gray' : 'none'} width={{ base: '80px', sm: '114.25px' }} height={'89.5px'} cursor={'pointer'} alt={`Facility-Details-Image-${index + 1}`} onClick={() => setSelectedIndex(index)} />
                            </WrapItem>
                        })}
                    </Wrap>
                </Box>
                {textOverlay && <Box w='auto'>
                    <Text textStyle={'h2'} textAlign='justify' >{textOverlay?.title}</Text>
                    <Text textStyle={'body1'} mt={'24px'} textAlign='justify' dangerouslySetInnerHTML={{ "__html": textOverlay?.subTitle }} />
                </Box>}
            </Flex>

        </Flex>
    )
}